import { render, staticRenderFns } from "./Display.vue?vue&type=template&id=50aa72e9&scoped=true&"
import script from "./Display.vue?vue&type=script&lang=js&"
export * from "./Display.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50aa72e9",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/usr/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('50aa72e9', component.options)
    } else {
      api.reload('50aa72e9', component.options)
    }
    module.hot.accept("./Display.vue?vue&type=template&id=50aa72e9&scoped=true&", function () {
      api.rerender('50aa72e9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/insights/Display.vue"
export default component.exports